import React from 'react';

// import Sidemenu_btsp from "../components/sidemenu_btsp";
import UnderConstruction from '../components/under_construction';

class Account extends React.Component {
    render () {
        return (
            <div className="container frame">
            <div className="row">
                <div className="col-3">
                    <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <a className="nav-link active" id="v-pills-home-tab" 
                        data-toggle="pill" href="#v-pills-home" role="tab" 
                        aria-controls="v-pills-home" aria-selected="true">Account</a>
                    <a className="nav-link" id="v-pills-profile-tab" 
                        data-toggle="pill" href="#v-pills-profile" role="tab" 
                        aria-controls="v-pills-profile" aria-selected="false">Edit Profile</a>
                    <a className="nav-link" id="v-pills-settings-tab" 
                        data-toggle="pill" href="#v-pills-settings" role="tab" 
                        aria-controls="v-pills-settings" aria-selected="false">Settings</a>
                    </div>
                </div>
                <div className="col-9">
                    <div className="tab-content" id="v-pills-tabContent">
                    <div className="tab-pane fade show active" id="v-pills-home" 
                        role="tabpanel" aria-labelledby="v-pills-home-tab">    
                        <div className="card">
                            <div className="card-header">
                                Contact Information
                            </div>
                            <div className="card-body">
                                <div className="card-text">
                                    <div className="info-box">
                                        <div className="flex-space-between">
                                            <div>Email</div>
                                            <div>example@email.com</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>    
                        <div className="card">
                            <div className="card-header">
                                Change Password
                            </div>
                            <div className="card-body">
                                <div className="card-text">
                                <form className="form-inline">
                                    <label className="sr-only" htmlFor="inlineFormInputName2">Username</label>
                                    <input type="text" className="form-control mb-2 mr-sm-2" id="inlineFormInputName2" 
                                        placeholder="Username"/>
                                    <label className="sr-only" htmlFor="inlineFormInputName2">Current Password</label>
                                    <input type="password" className="form-control mb-2 mr-sm-2" id="inlineFormInputName2" 
                                        placeholder="Current Password"/>
                                    <label className="sr-only" htmlFor="inlineFormInputName2">New Password</label>
                                    <input type="password" className="form-control mb-2 mr-sm-2" id="inlineFormInputName2" 
                                        placeholder="New Password"/>

                                    <button type="submit" className="btn btn-primary mb-2">Save</button>
                                </form>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header">
                                Deactivate Account
                            </div>
                            <div className="card-body">
                                <div className="card-text">
                                    <small>To deactivate your account, click the button.</small>
                                </div>
                                <a href="#" className="btn btn-primary float-right">Deactivate account</a>
                            </div>
                        </div>    
                    </div>

                    <div className="tab-pane fade" id="v-pills-profile" 
                        role="tabpanel" aria-labelledby="v-pills-profile-tab">
                        <UnderConstruction />
                    </div>
                    <div className="tab-pane fade" id="v-pills-settings" 
                        role="tabpanel" aria-labelledby="v-pills-settings-tab">
                        <UnderConstruction />    
                    </div>
                    </div>
                </div>
            </div>
            </div>
        )
    }
}

export default Account;